// #region Imports

import * as $ from 'jquery';

// #endregion Imports

// #region Exports

export function initialize(): void {
    bindCloseButtons();
    bindPlayButtons();
}

// #endregion Exports

// #region Private functions

function bindCloseButtons(): void {
    $('.js-close-video').click(handleCloseButtonClick);
}

function bindPlayButtons(): void {
    $('.js-play-video').click(handlePlayButtonClick);
}

function handleCloseButtonClick(e) {
    e.preventDefault();

    const $overlay = $(this).closest('.video-overlay');
    $overlay.removeClass('video-overlay--open');

    const $video = $overlay.find('.video-overlay__video');
    const html = $video.html();
    $video.html(html);  // Återställ videospelaren ifall uppspelning pågår

    if ($overlay[0]._handleKeydown) {
        $overlay[0].removeEventListener('keydown', $overlay[0]._handleKeydown);
    }

    const videoID = $(this).data('videoid');
    const playButton = $('[data-videoid="' + videoID + '"]');
    playButton.focus();
}

function handlePlayButtonClick(e: Event) {
    e.preventDefault();

    const target = $(this).data('videoid');
    const $modal = $(target);

    const $trigger = $(this);
    $modal.data('trigger', $trigger);

    $(target).addClass('video-overlay--open');

    const $video = $modal.find('video[controls]');
    $video.attr('tabindex', '0');

    $modal.focus();

    trapFocusAndEsc($modal[0]);

    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const video = $video[0] as HTMLVideoElement | undefined;

    if (video && isIOS) {
        if (!video.getAttribute('preload')) {
            video.setAttribute('preload', 'metadata');
        }

        const setThumbnail = () => {
            video.currentTime = 0.1;
        };

        if (video.readyState >= 1) {
            setThumbnail();
        } else {
            video.addEventListener('loadedmetadata', setThumbnail, { once: true });
            video.load();
        }
    }
}

function trapFocusAndEsc(modal) {

    const focusableSelectors = `
        a[href],
        button:not([disabled]),
        video[controls],
        textarea,
        input,
        select,
        [tabindex]:not([tabindex="-1"])
    `;

    const focusableElements = modal.querySelectorAll(focusableSelectors);
    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    function handleKeydown(e) {

        if (e.key === 'Tab') {
            if (e.shiftKey) { // Shift + Tab
                if (document.activeElement === firstElement) {
                    e.preventDefault();
                    lastElement.focus();
                }
            } else { // Tab
                if (document.activeElement === lastElement) {
                    e.preventDefault();
                    firstElement.focus();
                }
            }
        }

        if (e.key === 'Escape') {
            const closeButton = modal.querySelector('.js-close-video');
            if (closeButton) closeButton.click();
        }
    }

    modal.addEventListener('keydown', handleKeydown);
    modal._handleKeydown = handleKeydown; // spara referens för att ta bort senare
}

// #endregion Private functions